var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgNewsroom = function SvgNewsroom(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8954 2H19.8954C20.6913 1.99998 21.2198 2.00094 21.6011 2.03505C21.7792 2.05098 21.8848 2.07185 21.9428 2.08666C21.9484 2.11254 21.9547 2.14685 21.9609 2.19136C21.9977 2.45844 22 2.8448 22 3.5C22 3.9531 21.9999 4.94169 21.9998 6.2025C21.9995 9.29152 21.9991 14.0146 21.9995 16.5002C21.9997 18.1596 21.6941 19.5328 21.0061 20.4712C20.3609 21.351 19.2667 22 17.2996 22H6.57903H5V21.9387C5.71229 21.831 6.40658 21.5415 6.88499 20.784C7.19194 20.298 7.35363 19.6991 7.4476 19.0296C7.54278 18.3515 7.57903 17.516 7.57903 16.5L7.57903 3.5C7.57903 2.89778 7.58074 2.52394 7.61317 2.25517C7.62212 2.18101 7.63202 2.1298 7.64016 2.09596C7.67934 2.08451 7.74256 2.06958 7.83906 2.05558C8.12954 2.01343 8.55645 2 9.22538 2H19.8954ZM21.9232 2.01821C21.9232 2.01813 21.9239 2.01935 21.9249 2.02212C21.9237 2.01967 21.9232 2.01829 21.9232 2.01821Z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99902 22C2.52832 22 1.99902 20.5 2.00098 17C2.03193 15.5 2.00098 10 2.00098 10H7.49902",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 9.5V5.5H19V9.5H11Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 13.5H19",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11 17.5H17",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNewsroom);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/newsroom.8b062fc484f4d38132520331ffad84e3.svg";